import { createReducer, on } from '@ngrx/store';
import { ResetStateFromRouter } from 'src/app/shared/actions/eliqua.actions';
import { EditCampaignSuccess } from '../actions/campaign-search.actions';
import {
  ChannelChanged,
  ClearDateField,
  DescriptionChanged,
  EndDateChanged,
  ExportDataChanged,
  HelpTextChanged,
  NotesChanged,
  PriorityChanged,
  StartDateChanged,
  StatusChanged,
} from '../actions/wizard-configuration.actions';
import { CampaignSelectionTargetChanged } from '../actions/wizard-setup.actions';
import { CampaignEnumsSuccess, ResetWizard } from '../actions/wizard.actions';
import { WizardConfigurationState } from '../models/wizard.model';

const initialState: WizardConfigurationState = {
  helpTextStatus: false,
  campaignName: '',
  channels: [],
  channel: 'NO_CHANNEL',
  description: '',
  exportDataSelections: [],
  selectedExportDataSelections: [],
  startDate: '',
  endDate: '',
  priorities: ['LOW', 'NORMAL', 'HIGH'],
  priority: '',
  statusList: [],
  status: 'IN_DESIGN',
  notes: '',
};

export const WizardConfigurationReducer = createReducer(
  initialState,
  on(HelpTextChanged, (state) => ({
    ...state,
    helpTextStatus: !state.helpTextStatus,
  })),
  on(CampaignEnumsSuccess, (state, { campaignEnums }) => ({
    ...state,
    statusList: campaignEnums.statusTypes.filter(
      (status: string) => status !== 'LAUNCHED' && status !== 'NO_STATUS',
    ),
    channels: campaignEnums.campaignCommunicationChannels,
    exportDataSelections: campaignEnums.campaignExportDataSelections,
  })),
  on(ChannelChanged, (state, { channel }) => ({
    ...state,
    channel,
  })),
  on(StatusChanged, (state, { status }) => ({
    ...state,
    status,
  })),
  on(PriorityChanged, (state, { priority }) => ({
    ...state,
    priority,
  })),
  on(DescriptionChanged, (state, { description }) => ({
    ...state,
    description,
  })),
  on(NotesChanged, (state, { notes }) => ({
    ...state,
    notes,
  })),
  on(ExportDataChanged, (state, { selectedExportDataSelections }) => ({
    ...state,
    selectedExportDataSelections,
  })),
  on(StartDateChanged, (state, { startDate }) => ({
    ...state,
    startDate,
  })),
  on(EndDateChanged, (state, { endDate }) => ({
    ...state,
    endDate,
  })),
  on(ClearDateField, (state, { dateField }) => ({
    ...state,
    [dateField]: '',
  })),
  on(EditCampaignSuccess, (state, { campaign }) => {
    return {
      ...state,
      campaignName: campaign.data.campaignName,
      channel: campaign.data.campaignExecutionConfig.communicationChannel,
      description: campaign.data.campaignExecutionConfig.campaignExecutionDescription,
      selectedExportDataSelections: campaign.data.exportDataSelections,
      startDate: campaign.data.campaignFrom,
      endDate: campaign.data.campaignUntil,
      priority: campaign.data.campaignExecutionConfig.messagePriority,
      status: campaign.data.campaignStatus,
      notes: campaign.data.campaignNotes,
    };
  }),
  on(ResetWizard, (state) => ({
    ...initialState,
    channels: state.channels,
    exportDataSelections: state.exportDataSelections,
    statusList: state.statusList,
  })),
  on(CampaignSelectionTargetChanged, (state) => ({
    ...initialState,
    channels: state.channels,
    exportDataSelections: state.exportDataSelections,
    statusList: state.statusList,
  })),
  on(ResetStateFromRouter, () => ({
      ...initialState
  }))
);
